import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Trash2, Loader2, Mail, Phone, Check, Circle } from "lucide-react";
import { api } from "@/lib/api";

export const SubmissionsManager = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get("/admin/submissions");
      setItems(res.data);
    } catch (e) {
      toast.error("Kon aanvragen niet laden");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.put(`/admin/submissions/${id}/read`);
    setItems((prev) => prev.map((i) => (i.id === id ? { ...i, is_read: true } : i)));
  };

  const remove = async (id) => {
    if (!window.confirm("Deze aanvraag verwijderen?")) return;
    await api.delete(`/admin/submissions/${id}`);
    toast.success("Aanvraag verwijderd");
    setItems((prev) => prev.filter((i) => i.id !== id));
  };

  const fmt = (d) => {
    try { return new Date(d).toLocaleString("nl-NL", { dateStyle: "medium", timeStyle: "short" }); }
    catch { return d; }
  };

  if (loading) return <div className="text-white/40 flex items-center gap-2"><Loader2 className="animate-spin" size={18} /> Laden...</div>;

  const unread = items.filter((i) => !i.is_read).length;

  return (
    <div data-testid="submissions-manager">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-heading text-2xl font-bold text-white">Aanvragen ({items.length}){unread > 0 && <span className="text-[#FF1A1A] text-sm ml-2">{unread} nieuw</span>}</h2>
      </div>

      {items.length === 0 ? (
        <p className="text-white/40">Nog geen aanvragen ontvangen.</p>
      ) : (
        <div className="flex flex-col gap-3">
          {items.map((s) => (
            <div key={s.id} data-testid={`submission-${s.id}`} className={`bg-[#111] border p-5 ${s.is_read ? "border-white/10" : "border-[#FF1A1A]/40"}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0">
                  <div className="flex items-center gap-3 flex-wrap">
                    {!s.is_read && <Circle size={9} className="fill-[#FF1A1A] text-[#FF1A1A]" />}
                    <span className="text-white font-semibold">{s.name}</span>
                    <span className="text-xs px-2 py-0.5 bg-[#FF1A1A]/15 text-[#FF1A1A] uppercase tracking-wide">{s.type}</span>
                    <span className="text-white/30 text-xs">{fmt(s.created_at)}</span>
                  </div>
                  <div className="flex items-center gap-5 mt-2 text-sm text-white/60 flex-wrap">
                    <a href={`tel:${s.phone}`} className="flex items-center gap-1.5 hover:text-white"><Phone size={14} /> {s.phone}</a>
                    <a href={`mailto:${s.email}`} className="flex items-center gap-1.5 hover:text-white"><Mail size={14} /> {s.email}</a>
                  </div>
                  <p className="text-white/70 text-sm mt-3 whitespace-pre-wrap">{s.message}</p>
                </div>
                <div className="flex flex-col gap-2 shrink-0">
                  {!s.is_read && (
                    <button onClick={() => markRead(s.id)} data-testid={`mark-read-${s.id}`} className="text-white/60 hover:text-white border border-white/15 p-2" title="Markeer als gelezen"><Check size={15} /></button>
                  )}
                  <button onClick={() => remove(s.id)} data-testid={`delete-submission-${s.id}`} className="text-white/60 hover:text-[#FF1A1A] border border-white/15 p-2" title="Verwijder"><Trash2 size={15} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SubmissionsManager;
